import React, { useState, useEffect, useRef } from "react";
import DemoClasses from "./demo.module.css";
import Layout from "../../../Components/Layout/index";
import { Helmet } from "react-helmet";
import { Services } from "../../../Services";
import { FaSearch } from "react-icons/fa";
import SkeletonLoad from "./TableLoad/load";
import { Error } from "../../../Util/Toast";
import { toast } from "react-toastify";
import { FaEyeSlash } from "react-icons/fa";
import Moment from "react-moment";
import { MdEdit } from "react-icons/md";
import moment from "moment";
import Modal from "../Modal";
import swal from "sweetalert";
import { SuccessSwal } from "../../../Util/Toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "Components/loader/loader";
import { FaRegEye } from "react-icons/fa";
import { useForm } from "react-hook-form";
import ReactLoading from "react-loading";

import ReactPaginate from "react-paginate";
import Select from "react-select";
import ClaimUser from "./ClaimUser";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import UploadBulk from "./Bulkupload/upload";

function Demo() {
    const [details, setdetails] = useState({});
    const [showModal, setModal] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const Navigate = useNavigate();
    const timeoutRef = useRef(null);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [checkedData, setCheckedData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [RequestCreatedBy, setRequestCreatedBy] = useState(null);
    const [ClaimedBy, setClaimedBy] = useState(null);
    const [show, setShow] = useState(0);
    const [Apibody, setBody] = useState({ toSkip: 0 });
    const [data, setData] = useState([]);
    const admindata = JSON.parse(localStorage.getItem("admindata"));
    const [filterLoad, setFilterLoad] = useState(false);
    const [Sales, setSales] = useState([]);
    const [searchparams, setSearchParams] = useSearchParams();
    const [allAdmin, setAllAdmin] = useState([]);
    const [forcepage, setforcepage] = useState(0);
    const [pageCount, setpageCount] = useState(1);
    const [showPaginate, setShowPagiate] = useState(true);
    const [AllSms, setAllSms] = useState([]);
    const [SelectedData, setSelectedData] = useState([]);
    // const RecordCount = useStore((item) => item.NoOfRecords);
    const RecordCount = 20;
    const [refetch, setrefetch] = useState(true);
    const [isOpen, setisOpen] = useState(false);
    const [Url, setUrl] = useState("");
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm({ defaultValues: { IsReassigned: "All" } });
    const getAllCategories = (pageNumber, body) => {
        Services.Demo_Request(
            "POST",
            JSON.stringify({ toSkip: pageNumber, ...body }),
            token
        )
            .then((response) => {
                console.log(response);
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setData(response.DemoRequests);
                    if (
                        response.DemoRequests.length == 0 ||
                        response.Count <= RecordCount
                    ) {
                        setShowPagiate(false);
                    } else {
                        if (!showPaginate) {
                            setShowPagiate(true);
                        }
                        setpageCount(
                            Math.ceil(
                                Number(response?.RequestsCount) /
                                    Number(RecordCount)
                            )
                        );
                    }
                } else if (response.Status === 0) {
                    Error(response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    const DemorequestExport = () => {
        let FormData = watch();
        // Validate date ranges before proceeding:
        // - If either ClaimedFromDate or ClaimedToDate is present, both must be present.
        // - If either FromDate or ToDate is present, both must be present.
        // - At least one of the two ranges (ClaimedFrom/ClaimedTo OR FromDate/ToDate) must be provided.
        // - Each provided range must be at most 60 days long.
        const fromDate = FormData?.FromDate;
        const toDate = FormData?.ToDate;
        const claimedFrom = FormData?.ClaimedFromDate;
        const claimedTo = FormData?.ClaimedToDate;
        console.log(fromDate, toDate, claimedFrom, claimedTo);
        const swalMsgMissingPair = (label) =>
            `For Exporting Data please provide both ${label} From Date and ${label} To Date (max 60 days range)`;

        // check pair completeness
        if ((claimedFrom && !claimedTo) || (!claimedFrom && claimedTo)) {
            swal(swalMsgMissingPair("Assigned"), { icon: "warning" });
            return;
        }

        if ((fromDate && !toDate) || (!fromDate && toDate)) {
            swal(swalMsgMissingPair("Requested"), { icon: "warning" });
            return;
        }

        // require at least one complete range
        const hasClaimedRange = claimedFrom && claimedTo;
        const hasRequestedRange = fromDate && toDate;
        if (!hasClaimedRange && !hasRequestedRange) {
            swal(
                "For Exporting Data please provide either Assigned date range (ClaimedFromDate & ClaimedToDate) or Requested date range (FromDate & ToDate). Max 60 days range.",
                { icon: "warning" }
            );
            return;
        }

        // check 60 day max window per range
        const maxDays = 60;
        const parseDate = (d) => (d ? moment(d, "YYYY-MM-DD") : null);
        if (hasRequestedRange) {
            const a = parseDate(fromDate);
            const b = parseDate(toDate);
            if (!a.isValid() || !b.isValid()) {
                swal("Invalid Requested date range", { icon: "warning" });
                return;
            }
            const diff = b.diff(a, "days");
            if (diff < 0) {
                swal("Requested To Date must be same or after From Date", {
                    icon: "warning",
                });
                return;
            }
            if (diff > maxDays) {
                swal(`Requested date range cannot exceed ${maxDays} days`, {
                    icon: "warning",
                });
                return;
            }
        }
        if (hasClaimedRange) {
            const a = parseDate(claimedFrom);
            const b = parseDate(claimedTo);
            if (!a.isValid() || !b.isValid()) {
                swal("Invalid Assigned date range", { icon: "warning" });
                return;
            }
            const diff = b.diff(a, "days");
            if (diff < 0) {
                swal("Assigned To Date must be same or after From Date", {
                    icon: "warning",
                });
                return;
            }
            if (diff > maxDays) {
                swal(`Assigned date range cannot exceed ${maxDays} days`, {
                    icon: "warning",
                });
                return;
            }
        }
        let body;
        let data = { ...FormData };
        if (data?.IsReassigned != "All") {
            body = { IsReassigned: Number(data?.IsReassigned) };
        }

        if (data.MobileNumber) {
            body = {
                MobileNumber: data.MobileNumber,
                whether_Mobile_filter: 1,
            };
        }
        if (data.FromDate || data.ToDate) {
            if (data.FromDate) {
                if (!data.ToDate) {
                    body = {
                        ...body,
                        FromDate: data.FromDate,
                        ToDate: data?.FromDate,
                    };
                } else {
                    body = {
                        ...body,
                        FromDate: data.FromDate,
                        ToDate: data?.ToDate,
                    };
                }
            }
            if (data.ToDate) {
                if (!data.FromDate) {
                    body = {
                        ...body,
                        FromDate: data.ToDate,
                        ToDate: data?.ToDate,
                    };
                } else {
                    body = {
                        ...body,
                        FromDate: data.FromDate,
                        ToDate: data?.ToDate,
                    };
                }
            }
        }
        if (data.ClaimedFromDate || data.ClaimedToDate) {
            if (data.ClaimedFromDate) {
                if (!data.ClaimedToDate) {
                    body = {
                        ...body,
                        ClaimedFromDate: data.ClaimedFromDate,
                        ClaimedToDate: data?.ClaimedFromDate,
                    };
                } else {
                    body = {
                        ...body,
                        ClaimedFromDate: data.ClaimedFromDate,
                        ClaimedToDate: data?.ClaimedToDate,
                    };
                }
            }
            if (data.ClaimedToDate) {
                if (!data.ClaimedFromDate) {
                    body = {
                        ...body,
                        ClaimedFromDate: data.ClaimedFromDate,
                        ClaimedToDate: data?.ClaimedToDate,
                    };
                } else {
                    body = {
                        ...body,
                        ClaimedFromDate: data.ClaimedFromDate,
                        ClaimedToDate: data?.ClaimedToDate,
                    };
                }
            }
        }
        if (data?.AdminUserID) {
            body = { ...body, AdminUserID: data?.AdminUserID };
        }
        if (RequestCreatedBy) {
            body = {
                ...body,
                RequestCreatedBy: RequestCreatedBy.value,
                RequestCreatedByLabel: RequestCreatedBy.label,
            };
        }
        if (ClaimedBy) {
            body = {
                ...body,
                ClaimedBy: ClaimedBy.value,
                ClaimedByLabel: ClaimedBy.label,
            };
        }

        if (data?.CourseID) {
            body = { ...body, CourseID: data?.CourseID };
        }
        console.log(body);

        setLoadingDetails(true);
        Services.DemorequestExport("POST", JSON.stringify({ ...body }), token)
            .then((response) => {
                setLoadingDetails(false);
                if (response.Status === 1) {
                    window.open(response.CsvFile, "_blank");
                } else if (response.Status === 0) {
                    Error(response.message);
                }
            })
            .catch((err) => {
                setLoadingDetails(false);

                // alert(err);
                swal("something went wrong please try again", {
                    icon: "error",
                });
                console.log(err);
            });
    };

    useEffect(() => {
        getManagers();
        getAllAdmin();
        let prevData = localStorage.getItem("demo_filter");
        let page = searchparams.get("page");
        setforcepage(Number(page) - 1);
        if (prevData != "undefined") {
            prevData = JSON.parse(prevData);
            if (prevData?.FromDate) {
                setValue("FromDate", prevData?.FromDate);
            }
            if (prevData?.ToDate) {
                setValue("ToDate", prevData?.ToDate);
            }
            if (prevData?.MobileNumber) {
                setValue("MobileNumber", prevData?.MobileNumber);
            }
            if (prevData?.IsReassigned) {
                setValue("IsReassigned", prevData?.IsReassigned);
            }

            /*      if (prevData?.RequestCreatedBy) {
                //   setAllAdmin([
                    // { value: -1, label: "None" },
                    // { value: 0, label: "Parent" },
                    // {
                        // value: prevData?.RequestCreatedBy,
                        // label: prevData?.RequestCreatedByLabel,
                    // },
                // ]);
                let data = [
                    { value: -1, label: "None" },
                    { value: 0, label: "Parent" },
                    { value: 1, label: "Admin" },
                ];
                if (admindata.Type != 1) {
                    data = [
                        ...data,
                        {
                            value: admindata?.AdminUserID,
                            label: `${admindata?.FirstName} ${admindata?.LastName}`,
                        },
                    ];
                }
                setAllAdmin(data);
                setRequestCreatedBy({
                    value: prevData?.RequestCreatedBy,
                    label: prevData?.RequestCreatedByLabel,
                });
            } */
            if (prevData?.ClaimedBy) {
                setSales([
                    { value: "-1", label: "None" },
                    {
                        value: prevData?.ClaimedBy,
                        label: prevData?.ClaimedByLabel,
                    },
                ]);

                setClaimedBy({
                    value: prevData?.ClaimedBy,
                    label: prevData?.ClaimedByLabel,
                });
            }
            setBody(prevData);
            getAllCategories((Number(page) - 1) * RecordCount, prevData);
        } else {
            getAllCategories((Number(page) - 1) * RecordCount);
        }
    }, [refetch]);
    const claimHandler = (id, item) => {
        setCheckedData((prevSelected) => {
            return prevSelected.includes(id)
                ? prevSelected.filter((item) => item !== id)
                : [...prevSelected, id];
        });
        let allda = SelectedData.filter((leads) => leads.DemoRequestID != id);
        setSelectedData([...allda, item]);
        /*  swal("Are you sure about Claiming this User?", {
            icon: "warning",
            // className: detailsClass["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: "Cancel",
                catch: {
                    text: "Confirm",
                    value: "Logout",
                    // className: enrolledClasses["cancel"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Logout":
                    setFilterLoad(true);
                    Services.Claim_Enroll_Course_demo(
                        "PUT",
                        JSON.stringify(body),
                        token,
                        EnrollCourseID
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                SuccessSwal(
                                    "Success",
                                    "Student profile claimed successfully"
                                );
                                let page = searchparams.get("page");

                                getAllCategories(
                                    (Number(page) - 1) * RecordCount,
                                    Apibody
                                );
                                setFilterLoad(false);
                            } else {
                                setFilterLoad(false);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            setLoading(false);
                            Error("something went Wrong Please try again");
                            setFilterLoad(false);
                            // setFilterLoad(false)
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        }); */
    };
    const isSelected = (id) => checkedData.has(id);

    const resetClaimStatus = (EnrollCourseID) => {
        let body = {
            IsClaimed: 0,
            ClaimedBy: 0,
        };
        swal("Are you sure you want to un-claim the User?", {
            icon: "warning",
            // className: detailsClass["logout-popup"],
            dangerMode: true,
            buttons: {
                cancel: "Cancel",
                catch: {
                    text: "Confirm",
                    value: "Logout",
                    // className: enrolledClasses["cancel"],
                },
                defeat: false,
            },
        }).then((value) => {
            switch (value) {
                case "Logout":
                    setFilterLoad(true);
                    Services.Claim_Enroll_Course_demo(
                        "PUT",
                        JSON.stringify(body),
                        token,
                        EnrollCourseID
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                SuccessSwal(
                                    "Success",
                                    "Student profile claimed successfully"
                                );
                                getAllCategories();
                                setFilterLoad(false);
                            } else {
                                setFilterLoad(false);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            setLoading(false);
                            Error("something went Wrong Please try again");
                            setFilterLoad(false);
                            // setFilterLoad(false)
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };

    // }, [searchString]);
    const ClaimOnClickHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const onSubmit = (data) => {
        let body;
        if (data?.IsReassigned != "All") {
            body = { IsReassigned: Number(data?.IsReassigned) };
        }

        if (data.MobileNumber) {
            body = {
                MobileNumber: data.MobileNumber,
                whether_Mobile_filter: 1,
            };
        }
        if (data.FromDate || data.ToDate) {
            if (data.FromDate) {
                if (!data.ToDate) {
                    body = {
                        ...body,
                        FromDate: data.FromDate,
                        ToDate: data?.FromDate,
                    };
                } else {
                    body = {
                        ...body,
                        FromDate: data.FromDate,
                        ToDate: data?.ToDate,
                    };
                }
            }
            if (data.ToDate) {
                if (!data.FromDate) {
                    body = {
                        ...body,
                        FromDate: data.ToDate,
                        ToDate: data?.ToDate,
                    };
                } else {
                    body = {
                        ...body,
                        FromDate: data.FromDate,
                        ToDate: data?.ToDate,
                    };
                }
            }
        }
        if (data.ClaimedFromDate || data.ClaimedToDate) {
            if (data.ClaimedFromDate) {
                if (!data.ClaimedToDate) {
                    body = {
                        ...body,
                        ClaimedFromDate: data.ClaimedFromDate,
                        ClaimedToDate: data?.ClaimedFromDate,
                    };
                } else {
                    body = {
                        ...body,
                        ClaimedFromDate: data.ClaimedFromDate,
                        ClaimedToDate: data?.ClaimedToDate,
                    };
                }
            }
            if (data.ClaimedToDate) {
                if (!data.ClaimedFromDate) {
                    body = {
                        ...body,
                        ClaimedFromDate: data.ClaimedFromDate,
                        ClaimedToDate: data?.ClaimedToDate,
                    };
                } else {
                    body = {
                        ...body,
                        ClaimedFromDate: data.ClaimedFromDate,
                        ClaimedToDate: data?.ClaimedToDate,
                    };
                }
            }
        }
        if (data?.AdminUserID) {
            body = { ...body, AdminUserID: data?.AdminUserID };
        }
        if (RequestCreatedBy) {
            body = {
                ...body,
                RequestCreatedBy: RequestCreatedBy.value,
                RequestCreatedByLabel: RequestCreatedBy.label,
            };
        }
        if (ClaimedBy) {
            body = {
                ...body,
                ClaimedBy: ClaimedBy.value,
                ClaimedByLabel: ClaimedBy.label,
            };
        }

        if (data?.CourseID) {
            body = { ...body, CourseID: data?.CourseID };
        }
        setforcepage(0);
        setLoading(true);
        localStorage.setItem("demo_filter", JSON.stringify(body));

        setBody(body);
        setforcepage(0);
        getAllCategories(0, body);
    };

    const handlePageChange = (selectedObject) => {
        console.log(selectedObject);
        // setcurrentPage(selectedObject.selected);
        // handleFetch();
        setSearchParams({ page: selectedObject.selected + 1 });
        window.scrollTo({ top: 10, behavior: "instant" });
        setforcepage(selectedObject.selected);

        getAllCategories(selectedObject.selected * RecordCount, Apibody);
        setLoading(true);
    };
    const getManagers = () => {
        Services.list_salesmanger("GET", null, token)
            .then((response) => {
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setSales([
                        { value: "-1", label: "None" },
                        ...response?.AdminUsers?.map((item) => ({
                            label: `${item?.FirstName} ${item?.LastName}`,
                            value: item?.AdminUserID,
                        })),
                    ]);
                } else if (response.Status === 0) {
                    toast.error(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const getAllAdmin = () => {
        Services.listAllAdmin("POST", null, token)
            .then((response) => {
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    let data = [
                        { value: -1, label: "None" },
                        { value: 0, label: "Parent" },
                        { value: -2, label: "Admin" },
                        {
                            value: 1,
                            label: "Super Admin",
                        },
                    ];
                    if (admindata.Type != 1 && admindata.Type != 7) {
                        data = [
                            ...data,
                            {
                                value: admindata?.AdminUserID,
                                label: `${admindata?.FirstName} ${admindata?.LastName}`,
                            },
                        ];
                    } else {
                        data = [
                            ...data,
                            ...response?.AdminUsers?.map((item) => ({
                                label: `${item?.FirstName} ${item?.LastName}`,
                                value: item?.AdminUserID,
                            })),
                        ];
                    }
                    setAllAdmin(data);

                    setAllSms([
                        { value: "-1", label: "None" },
                        ...response?.AdminUsers?.filter(
                            (item) => item.Type == 5 || item.Type == 10
                        ).map((item) => ({
                            label: `${item?.FirstName} ${item?.LastName}`,
                            value: item?.AdminUserID,
                        })),
                    ]);
                } else if (response.Status === 0) {
                    toast.error(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const clearHandler = () => {
        localStorage.removeItem("demo_class_filter");
        reset();
        setClaimedBy(null);
        setRequestCreatedBy(null);
        setBody(null);
        setforcepage(0);
        getAllCategories(0);
    };

    const showHandler = (e, id) => {
        e.stopPropagation();
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setShow(id);
        timeoutRef.current = setTimeout(() => {
            setShow(0);
        }, 10000);
    };

    return (
        <Layout Active={"Demo Requests"}>
            {showUpload && (
                <UploadBulk setModal={setShowUpload} shwoModal={showUpload} />
            )}
            {isOpen && (
                <ClaimUser
                    isOpen={isOpen}
                    setIsOpen={setisOpen}
                    options={AllSms}
                    checkedData={checkedData}
                    setrefetch={setrefetch}
                    setCheckedData={setCheckedData}
                    SelectedData={SelectedData}
                    setSelectedData={setSelectedData}
                />
            )}
            {showModal && (
                <Modal
                    getDetails={details}
                    modal={showModal}
                    setModal={setModal}
                    getAllCategories={getAllCategories}
                />
            )}
            <Helmet>
                <meta charSet="utf-8" />
                <title>Demo Requests</title>
            </Helmet>
            {filterLoad && <Loader />}

            <div className={DemoClasses["Container"]}>
                {/*   <div className={DemoClasses["control-btns"]}>
                    <div>
                        <FaSearch className={DemoClasses["search-icon"]} />
                        <input
                            onChange={(e) => setSearchString(e.target.value)}
                            value={searchString}
                            type="number"
                            placeholder="Search By Mobile Number"
                        />
                    </div>
                </div> */}

                <div className={DemoClasses["Tutor"]}>
                    <h3>
                        Demo Requests
                        <button onClick={() => Navigate("/add-demo-student")}>
                            {" "}
                            + Add Demo Request
                        </button>
                        {(admindata.Type == 1 || admindata.Type == 7) && (
                            <button onClick={() => setShowUpload(true)}>
                                Bulk Upload
                            </button>
                        )}
                    </h3>
                    <form
                        className={DemoClasses["Filter"]}
                        onSubmit={handleSubmit(onSubmit)}
                        style={{ width: "100%" }}>
                        <div className={DemoClasses["form_control"]}>
                            <label htmlFor="">Mobile Number</label>
                            <div>
                                <FaSearch
                                    className={DemoClasses["search-icon"]}
                                />
                                <input
                                    {...register("MobileNumber", {
                                        required: false,
                                    })}
                                    type="number"
                                    placeholder="Mobile Number"
                                />
                            </div>
                        </div>
                        {(admindata.Type == 1 || admindata.Type == 7) && (
                            <div className={DemoClasses["form_control"]}>
                                <label htmlFor="">From Date</label>
                                <input
                                    style={{ textTransform: "uppercase" }}
                                    {...register("FromDate", {
                                        required: false,
                                    })}
                                    type="date"
                                />
                            </div>
                        )}

                        {(admindata.Type == 1 || admindata.Type == 7) && (
                            <div className={DemoClasses["form_control"]}>
                                <label htmlFor="">To Date</label>
                                <input
                                    style={{ textTransform: "uppercase" }}
                                    {...register("ToDate", {
                                        required: false,
                                    })}
                                    type="date"
                                />
                            </div>
                        )}
                        <div className={DemoClasses["form_control"]}>
                            <label htmlFor="">Reassigned</label>
                            <select name="" id="" {...register("IsReassigned")}>
                                <option value="All"> </option>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                        {
                            <div className={DemoClasses["form-control"]}>
                                <label htmlFor="Tutor">Requested By </label>
                                <Select
                                    options={allAdmin}
                                    onChange={(value) =>
                                        setRequestCreatedBy(value)
                                    }
                                    value={RequestCreatedBy}
                                    placeholder="Search"
                                    noOptionsMessage={() => "No Data Found"}
                                    classNames={DemoClasses["select"]}
                                    styles={{
                                        // Set the width to 100%
                                        control: (provided) => ({
                                            ...provided,
                                            width: "14rem",
                                            borderRadius: "10px",
                                        }),
                                    }}
                                    isClearable
                                    components={{
                                        ClearIndicator: () => (
                                            <button
                                                onClick={() =>
                                                    setRequestCreatedBy(null)
                                                }>
                                                Clear
                                            </button>
                                        ),
                                    }}
                                />
                            </div>
                        }
                        {(admindata.Type == 1 || admindata.Type == 7) && (
                            <div className={DemoClasses["form-control"]}>
                                <label htmlFor="Tutor">Lead Owner</label>
                                <Select
                                    options={Sales}
                                    onChange={(value) => setClaimedBy(value)}
                                    value={ClaimedBy}
                                    placeholder="Search"
                                    noOptionsMessage={() => "No Data Found"}
                                    classNames={DemoClasses["select"]}
                                    styles={{
                                        // Set the width to 100%
                                        control: (provided) => ({
                                            ...provided,
                                            width: "14rem",
                                            borderRadius: "10px",
                                        }),
                                    }}
                                    isClearable
                                    components={{
                                        ClearIndicator: () => (
                                            <button
                                                onClick={() =>
                                                    setClaimedBy(null)
                                                }>
                                                Clear
                                            </button>
                                        ),
                                    }}
                                />
                            </div>
                        )}
                        <div className={DemoClasses["form_control"]}>
                            <label htmlFor="">Assigned From Date</label>
                            <input
                                style={{ textTransform: "uppercase" }}
                                {...register("ClaimedFromDate", {
                                    required: false,
                                })}
                                type="date"
                            />
                        </div>
                        <div className={DemoClasses["form_control"]}>
                            <label htmlFor="">Assigned To Date</label>
                            <input
                                style={{ textTransform: "uppercase" }}
                                {...register("ClaimedToDate", {
                                    required: false,
                                })}
                                type="date"
                            />
                        </div>
                        <button>Submit</button>
                        <button
                            style={{
                                border: "1px solid #0077b6",
                                backgroundColor: "white",
                                color: "#0077b6",
                            }}
                            onClick={clearHandler}>
                            Clear
                        </button>
                        {(admindata.Type == 1 || admindata.Type == 7) && (
                            <button type="button" onClick={DemorequestExport}>
                                Export
                            </button>
                        )}
                    </form>
                    {loading ? (
                        <SkeletonLoad count={8} />
                    ) : data.length > 0 ? (
                        <div className={DemoClasses["Table"]}>
                            <table style={{ minWidth: "1200px" }}>
                                <thead>
                                    <tr>
                                        {(admindata.Type == 1 ||
                                            admindata.Type == 7) && <th></th>}
                                        <th>Parent</th>
                                        <th>Student</th>
                                        <th>Course</th>

                                        <th>Requested Date</th>

                                        {<th>Requested By</th>}
                                        {(admindata.Type == 1 ||
                                            admindata.Type == 7) && (
                                            <th>Lead Owner</th>
                                        )}
                                        <th>Assigned Date</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item) => (
                                        <tr
                                            onClick={() => {
                                                if (
                                                    (admindata.Type == 1 ||
                                                        admindata.Type == 7) &&
                                                    item.CanClaim == 1
                                                ) {
                                                    claimHandler(
                                                        item.DemoRequestID,
                                                        item
                                                    );
                                                }
                                            }}>
                                            {(admindata.Type == 1 ||
                                                admindata.Type == 7) && (
                                                <td style={{ width: "2rem" }}>
                                                    <input
                                                        onChange={() =>
                                                            claimHandler(
                                                                item.DemoRequestID,
                                                                item
                                                            )
                                                        }
                                                        onClick={(e) =>
                                                            e.stopPropagation()
                                                        }
                                                        disabled={
                                                            item.CanClaim == 0
                                                        }
                                                        type="checkbox"
                                                        checked={checkedData.includes(
                                                            item.DemoRequestID
                                                        )}
                                                    />
                                                </td>
                                            )}
                                            <td
                                                style={{
                                                    width: "10rem",
                                                    wordBreak: "break-word",
                                                }}>
                                                {" "}
                                                {item.ParentName}
                                                <br />({item.CountryCode}
                                                {show != item.DemoRequestID
                                                    ? "xxxxxxxxxx"
                                                    : item.MobileNumber}
                                                ){" "}
                                                <button
                                                    style={{
                                                        border: "none",
                                                        background: "none",
                                                    }}
                                                    onClick={(e) =>
                                                        showHandler(
                                                            e,
                                                            item.DemoRequestID
                                                        )
                                                    }>
                                                    {show !=
                                                    item.DemoRequestID ? (
                                                        <FaEyeSlash />
                                                    ) : (
                                                        <FaRegEye />
                                                    )}
                                                </button>
                                            </td>
                                            <td>{item.StudentName}</td>
                                            <td>{item.CourseName}</td>
                                            {
                                                <td>
                                                    <Moment
                                                        subtract={{
                                                            hours: 5,
                                                            minutes: 30,
                                                        }}
                                                        format="DD-MM-YYYY">
                                                        {
                                                            new Date(
                                                                item.CreatedAt
                                                            )
                                                        }
                                                    </Moment>
                                                </td>
                                            }

                                            <td>
                                                {item?.RequestCreatedBy_Type ==
                                                4
                                                    ? "Parent"
                                                    : item?.RequestCreatedByName}

                                                <br />
                                                {item?.IsReassigned == 1 &&
                                                    "(Reassigned)"}
                                            </td>

                                            {(admindata.Type == 1 ||
                                                admindata.Type == 7) && (
                                                <td>
                                                    {item?.ClaimedByName
                                                        ? `${item?.ClaimedByName}`
                                                        : ""}
                                                </td>
                                            )}
                                            <td>
                                                <Moment format="DD-MM-YYYY" utc>
                                                    {item.ClaimedDate}
                                                </Moment>
                                            </td>
                                            <td>
                                                <div
                                                    className={
                                                        DemoClasses[
                                                            "Action-btns"
                                                        ]
                                                    }>
                                                    {/* {(admindata.Type == 1 ||
                                                        admindata.Type == 8 ||
                                                        admindata?.AdminUserID ==
                                                            142) && (
                                                        <button
                                                            onClick={() =>
                                                                resetClaimStatus(
                                                                    item?.DemoRequestID
                                                                )
                                                            }
                                                            disabled={
                                                                item?.ClaimedByName ==
                                                                null
                                                            }>
                                                            Reset Claim
                                                        </button>
                                                    )} */}
                                                    <button
                                                        className={
                                                            DemoClasses[
                                                                "edit-btn"
                                                            ]
                                                        }
                                                        onClick={() => {
                                                            localStorage.setItem(
                                                                "demo",
                                                                JSON.stringify({
                                                                    ...item,
                                                                    DOB: moment(
                                                                        item?.DOB
                                                                    ).format(
                                                                        "YYYY-MM-DD"
                                                                    ),
                                                                })
                                                            );
                                                            Navigate(
                                                                `/add-demo-student?id=${item.DemoRequestID}`
                                                            );
                                                        }}>
                                                        <MdEdit />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {checkedData.length > 0 && (
                                <button
                                    style={{
                                        marginTop: "1rem",
                                        justifySelf: "center",
                                        color: "white",
                                        backgroundColor: "#0077b6",
                                    }}
                                    onClick={() => setisOpen(true)}
                                    className={
                                        DemoClasses["claim_data_button"]
                                    }>
                                    Reassign Lead
                                </button>
                            )}
                            {showPaginate && (
                                <div
                                    style={{
                                        justifySelf: "right",
                                    }}>
                                    <ReactPaginate
                                        pageCount={pageCount}
                                        // pageRange={2}
                                        forcePage={forcepage}
                                        marginPagesDisplayed={2}
                                        onPageChange={handlePageChange}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        containerClassName={"pagination"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                </div>
                            )}
                        </div>
                    ) : (
                        <div>
                            {" "}
                            <p>No Record Found</p>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Demo;
